import { Text, Tooltip } from "@powerledger/ui-component-lib";
import { useTranslation } from "react-i18next";

type AnonymizeTooltipProps = {
  tooltipId: string;
};

const AnonymizeTooltip = ({ tooltipId }: AnonymizeTooltipProps) => {
  const { t } = useTranslation();
  return (
    <Tooltip
      id={tooltipId}
      content={<Text>{t("You’ve anonymized this project name. It is not visible to buyers.")}</Text>}
      sx={{
        marginBottom: 0,
        display: "flex",
        minWidth: 24,
      }}
    />
  );
};

export default AnonymizeTooltip;
